module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAPdJREFUOI2tk0FywjAMRb9oNxE78nOempv0Jgk3aU9S5ybsK7Zmh1gEt5k2MQnDn/GMZWueZEkGniQZGySDQ1oAcHjcAL2ZxSWgl7zZkS0g7wI/+G+cD9VtV6liqyoppeNdUKUaABxPZp/nlPrbOlSqP9BKFeeU+mJqNRsnGe74fM35bP4ekAw1G59yBoAL8LYIVJLD49zdP5CZRYHvS8Ad2dZsfFyOyYxKLRdIJ5BwCxbzuEyChlGYlsO7k33vzSyOnzpZbIF0c6A5rSr2KtCSYi8CZdhTQI/oFci/fphakrPOFwACCST7bGcJMLRbIOHRbEoTv1pXeONeja+B3jMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliSchool.png
// module id = +pyf
// module chunks = 1